import * as Yup from 'yup'

const professionFormSchema = Yup.object({
  profession: Yup.string().required('Debes especificar tu profesión'),
})

export default professionFormSchema
